export default "__VITE_ASSET__DGDNXi4k__"